export const NETWORK_ERROR_MESSAGE = '网络异常! ';
export const TOKEN_EXPIRED_MESSAGE = '登录态过期! ';
export const UNAUTHENCATIED_MESSAGE = '对不起，您的权限不足！若需相关操作权限，请联系管理员。 ';

//管理员页面
export const ADD_ADMIN_SUCCESS_MESSAGE = '添加管理员成功！';
export const ADD_ADMIN_ERROR_MESSAGE = '添加管理员失败！';
export const EDIT_ADMIN_SUCCESS_MESSAGE = '编辑管理员成功！';
export const EDIT_ADMIN_ERROR_MESSAGE = '编辑管理员失败！';
export const GET_ADMIN_ERROR_MESSAGE = '未找到对应管理员信息！';
export const INVALID_ADMIN_OPERATION_ERROR_MESSAGE = '不能编辑或禁用当前登录的账号！';
export const INVALID_ADMIN_CONFIRM_MESSAGE = '确定要禁用该管理员吗？';
export const VALID_ADMIN_CONFIRM_MESSAGE = '确定要启用该管理员吗？';
//公司 & 客户管理页面
export const LOGO_NOT_UPLOAD = '未上传';
export const LOGO_LINK_NOT_AVALIABLE = '图片失效';
export const INVALID_COMPANY_CONFIRM_MESSAGE = '确定要禁用该公司吗？';
export const VALID_COMPANY_CONFIRM_MESSAGE_CONFIRM_MESSAGE = '确定要启用该公司吗？';
export const ADD_COMPNAY_SUCCESS_MESSAGE = '添加公司成功！';
export const ADD_COMPNAY_ERROR_MESSAGE = '添加公司失败！';
export const EDIT_COMPNAY_SUCCESS_MESSAGE = '编辑公司成功！';
export const EDIT_COMPNAY_ERROR_MESSAGE = '编辑公司失败！';
export const GET_COMPNAY_ERROR_MESSAGE = '未找到对应公司信息！';
export const ADD_CONTACT_SUCCESS_MESSAGE = '添加客户沟通信息成功！';
export const ADD_CONTACT_ERROR_MESSAGE = '添加客户沟通信息失败！';
export const EDIT_CONTACT_SUCCESS_MESSAGE = '编辑客户沟通信息成功！';
export const EDIT_CONTACT_ERROR_MESSAGE = '编辑客户沟通信息失败！';
export const GET_CONTACT_ERROR_MESSAGE = '未找到对应客户沟通信息！';

export const INVALID_CUSTOMER_CONFIRM_MESSAGE = '确定要禁用该客户吗？';
export const VALID_CUSTOMER_CONFIRM_MESSAGE = '确定要启用该客户吗？';
export const KEY_CUSTOMER_CHANGE_CONFIRM_MESSAGE = '确定要将该客户更改为主要联系人吗？';
export const KEY_CUSTOMER_CANCEL_CONFIRM_MESSAGE = '确定要将该客户更改为非主要联系人吗？';
export const KEY_CUSTOMER_HINT_MESSAGE = '勾选后表示客户为培训的主要联系人';
export const KEY_CUSTOMER_SELECTOR_HINT_MESSAGE = '选择“是”表示客户为培训的主要联系人';
export const WRONG_MOBILE_NUMBER_MESSAGE = '输入的手机号不是11位，是否确认提交？';
export const ADD_CUSTOMER_SUCCESS_MESSAGE = '添加客户成功！';
export const ADD_CUSTOMER_ERROR_MESSAGE = '添加客户失败！';
export const EDIT_CUSTOMER_SUCCESS_MESSAGE = '编辑客户成功！';
export const EDIT_CUSTOMER_ERROR_MESSAGE = '编辑客户失败！';
export const GET_CUSTOMER_ERROR_MESSAGE = '未找到对应客户信息！';
export const IMPORT_CUSTOMER_SUCCESS_INSERT = '成功插入数据： ';
export const IMPORT_CUSTOMER_SUCCESS_UPDATE = '成功更新数据： ';
export const IMPORT_CUSTOMER_SKIP = '跳过执行数据： ';
export const IMPORT_CUSTOMER_FAILED = '操作失败数据： ';
export const IMPORT_DETAIL_MESSAGE = '详细信息： \n';
export const IMPORT_CUSTOMER_QUANTITY = ' 条\n';
export const REQUIREMNET_HISTORY_DELETE_CONFIRM_MESSAGE = '确认删除该需求历史记录吗？';

// 客户经理
export const ADD_CUSTOMER_MANAGER_SUCCESS_MESSAGE = '新增客户经理成功！';
export const ADD_CUSTOMER_MANAGER_ERROR_MESSAGE = '新增客户经理失败！';
export const EDIT_CUSTOMER_MANAGER_SUCCESS_MESSAGE = '编辑客户经理成功！';
export const EDIT_CUSTOMER_MANAGER_ERROR_MESSAGE = '编辑客户经理失败！';
export const TERMINATE_CUSTOMER_MANAGER_CONFIRM_MESSAGE = '确认将该客户经理状态改为终止吗？';

// 顾问
export const ADD_CONSULTANT_SUCCESS_MESSAGE = '新增顾问成功！';
export const ADD_CONSULTANT_ERROR_MESSAGE = '新增顾问失败！';
export const EDIT_CONSULTANT_SUCCESS_MESSAGE = '编辑顾问成功！';
export const EDIT_CONSULTANT_ERROR_MESSAGE = '编辑顾问失败！';
export const DELETE_CONSULTANT_CONFIRM_MESSAGE = '确认删除该顾问吗？';
export const TERMINATE_CONSULTANT_CONFIRM_MESSAGE = '确认将该顾问状态改为终止吗？';
export const UPLOAD_CONSULTANT_ATTACHMENT_SUCCESS_MESSAGE = '上传顾问附件成功！';
export const UPLOAD_CONSULTANT_ATTACHMENT_ERROR_MESSAGE = '上传顾问附件失败！';

// 项目
export const ADD_PROJECT_SUCCESS_MESSAGE = '新增项目成功！';
export const ADD_PROJECT_ERROR_MESSAGE = '新增项目失败！';
export const EDIT_PROJECT_SUCCESS_MESSAGE = '编辑项目成功！';
export const EDIT_PROJECT_ERROR_MESSAGE = '编辑项目失败！';
export const DELETE_PROJECT_CONFIRM_MESSAGE = '确认删除该项目吗？';
export const DELETE_PROJECT_STAGE_CONFIRM_MESSAGE = '确认删除该项目阶段吗？';
export const UPLOAD_PROJECT_ATTACHMENT_SUCCESS_MESSAGE = '上传项目附件成功！';
export const UPLOAD_PROJECT_ATTACHMENT_ERROR_MESSAGE = '上传项目附件失败！';

//文件上传控件
export const ADD_FILE_SUCCESS_MESSAGE = '上传文件信息成功！';
export const ADD_FILE_ERROR_MESSAGE = '上传文件信息失败！';
export const EDIT_FILE_SUCCESS_MESSAGE = '更新文件信息成功！';
export const EDIT_FILE_ERROR_MESSAGE = '更新文件信息失败！';
export const GET_FILE_ERROR_MESSAGE = '获取文件信息失败！';
export const IMAGE_UPLOAD_SUCCESS_MESSAGE = '图片上传成功! ';
export const IMAGE_UPLOAD_ERROR_MESSAGE = '图片上传失败! ';
export const VIDEO_UPLOAD_SUCCESS_MESSAGE = '视频上传成功! ';
export const VIDEO_UPLOAD_ERROR_MESSAGE = '视频片上传失败! ';
export const AUDIO_UPLOAD_SUCCESS_MESSAGE = '音频上传成功! ';
export const AUDIO_UPLOAD_ERROR_MESSAGE = '音频上传失败! ';
export const DOCUMENT_UPLOAD_SUCCESS_MESSAGE = '文档上传成功! ';
export const DOCUMENT_UPLOAD_ERROR_MESSAGE = '文档上传失败! ';
export const FILE_UPLOAD_SUCCESS_MESSAGE = '文件上传成功! ';
export const FILE_UPLOAD_ERROR_MESSAGE = '文件上传失败! ';
export const UPLOAD_FILE_TYPE_ERROR_MESSAGE = '文件格式错误，请上传正确的文件类型! ';
export const UPLOAD_MULTI_FILE_ERROR_MESSAGE = '不支持上传多个文件! ';
